/**
 * [P0 invite-gated access] Where an invited manager lands after joining.
 *
 * A league that is already mid-draft must drop them into the live room (that
 * is the reconnect path); anything else opens the lobby. Shared so the
 * post-register flow and the logged-in join page cannot drift apart.
 */
export const PENDING_INVITE_KEY = "pendingInviteCode";

export function postJoinPath(league) {
  const id = league?.id;
  if (!id) return "/dashboard";
  const status = league.status;
  if (status === "DRAFTING" || status === "PAUSED") {
    const fmt = league.settings?.draft_format || "auction";
    return fmt === "snake" ? `/draft-snake/${id}` : `/draft/${id}`;
  }
  return `/league/${id}/lobby`;
}

export function readPendingInviteCode() {
  try {
    return sessionStorage.getItem(PENDING_INVITE_KEY) || null;
  } catch {
    return null;
  }
}

/**
 * [P0 HOTFIX] The invite code must survive EVERY entry point, not just
 * `/join/<code>` (which stashes it before redirecting to /signup).
 * `/signup?code=<code>` - the link shape used when sharing a code directly -
 * had nothing in the stash, so the invite-only guard bounced the user to
 * /login before the form ever rendered.
 *
 * Reads the query first and persists it, so a later re-render (or the join
 * call after register) still has it.
 */
export function resolveInviteCode(search = "") {
  let fromQuery = null;
  try {
    fromQuery = new URLSearchParams(search).get("code");
  } catch {
    fromQuery = null;
  }
  if (fromQuery) {
    try { sessionStorage.setItem(PENDING_INVITE_KEY, fromQuery); } catch { /* private mode */ }
    return fromQuery;
  }
  return readPendingInviteCode();
}

export function clearPendingInviteCode() {
  try {
    sessionStorage.removeItem(PENDING_INVITE_KEY);
  } catch {
    /* private-mode storage - nothing to clear */
  }
}
